import PropTypes from 'prop-types';
import { Box, Typography, TableRow } from '@mui/material';
import PriceComponent from 'components/PriceComponent';
import StyledTableCell from 'components/SummaryComponent/StyledTableCell';
import BookMaterialModal from 'components/BookMaterialComponent/BookMaterialModal';

function BookMaterialComponent({
  bookMaterialChargedBefore,
  bookMaterialNote,
  bookMaterialPriceExchanged,
}) {
  return (
    <TableRow key="bookMaterial">
      <StyledTableCell component="th" scope="row">
        Material didático
      </StyledTableCell>
      <StyledTableCell align="right">
        <Typography variant="body2" component="div">
          <Box
            component="span"
            fontSize={12}
            fontWeight={900}
            textAlign="right"
          >
            {bookMaterialPriceExchanged > 0 && bookMaterialChargedBefore ? (
              <PriceComponent value={bookMaterialPriceExchanged} />
            ) : (
              <Box display="flex" alignItems="center" justifyContent="end">
                {bookMaterialNote && (
                  <BookMaterialModal contentBookNote={bookMaterialNote} />
                )}
                {bookMaterialChargedBefore ? (
                  <strong>GRÁTIS</strong>
                ) : (
                  <strong>NÃO INCLUSO</strong>
                )}
              </Box>
            )}
          </Box>
        </Typography>
      </StyledTableCell>
    </TableRow>
  );
}

export default BookMaterialComponent;

BookMaterialComponent.propTypes = {
  bookMaterialPriceExchanged: PropTypes.number.isRequired,
  bookMaterialNote: PropTypes.string,
};

BookMaterialComponent.defaultProps = {
  bookMaterialNote: '',
};
